export default {"src":"https://assetscdn1.paytm.com/movies_new/_next/static/media/mdpabout.c6cfdea6.svg","height":1351,"width":375};